import { Component, OnInit } from '@angular/core';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styles: []
})
export class LogoutComponent implements OnInit {

  constructor( private service: AzureAuthService, private router: Router, private toasterService: ToastrService, private broadcastService: MsalBroadcastService) { }

  ngOnInit(): void {
    this.service.logout();
    /*if (this.service.isAuthenticated()) {
      this.router.navigate(['/home']);
    }*/
  }

  loginAzure() {
    this.service.login().subscribe({
      next: (result: AuthenticationResult) => {
        // Authentication successful
        console.log('Login successful:', result);
        // Navigate to /home
        this.router.navigate(['/home']);
      },
      error: (error) => {
        // Handle authentication errors
        console.error('Login failed:', error);
        // Optional: Display an error message to the user
      }
    });
  }

}
